export default {
  login: {
    email_input: 'email-id',
    password_input: 'password-id',
    submit_button: 'login_submit_button',
    register_button: 'login_register_button',
    logout_button: 'logout'
  },

  register: {
    search_input: 'register_search_input',
    search_button: 'register_search_button',
    register_button: 'register',
    building_search: 'search-id',
    search_building_confirm: 'search_building_confirm',
    dob: 'register_dob',
    step_2_continue: 'step_2_continue',
    account_details: {
      name: 'name-id',
      email: 'email-id',
      password: 'password-id',
      step_3_continue: 'step_3_continue'
    },
    pin: {
      otp1: 'otp-1',
      otp2: 'otp-2',
      otp3: 'otp-3',
      otp4: 'otp-4'
    },
    job_role: {
      select_role: 'select-role',
      step_4_continue: 'step_4_continue'
    },
    travel_info: {
      skip: 'skip'
    },
    floor_info: {
      step_6_continue: 'step_6_continue',
      select_floor: 'select-floor'
    },
    profile_photo: {
      skip: 'skip',
      choose: 'choose',
      upload: 'upload',
      file_upload: 'file_upload',
      use: 'use'
    },
    terms_and_conditions: 'terms_and_conditions',
    registration_complete: {
      submit: 'registration_complete'
    }
  },

  nav: {
    platform_management: 'nav-link-platform-management',
    building_management: 'nav-link-building-management',
    mobile_app: 'nav-link-mobile-app',
    articles: 'nav-link-articles',
    users: 'nav-link-users',
    occupiers: 'nav-link-occupiers',
    notifications: 'nav-link-notifications',
    settings: 'nav-link-settings',
    avatar: 'avatar',
    toggle_submenu: 'toggle_submenu'
  },

  doc_store: {
    drop_zone: 'drop_zone'
  },

  platform_management: {
    buildings: {
      table_list: 'buildings_table_list',
      create_new: 'new_button',
      row_info: 'row_info',
      new: {
        building_name: 'building_name',
        portal_uri: 'portal_uri',
        client_select: 'client_id',
        tier_type_select: 'tier_type_id',
        adminUserEmail: 'adminUserEmail',
        address_1: 'address1',
        address_2: 'address2',
        address_3: 'address3',
        city: 'city',
        county: 'county',
        postcode: 'postcode',
        latitude: 'latitude',
        longitude: 'longitude',
        submit: 'submit',
        confirm_submit: 'confirm_submit'
      }
    },
    companies: {
      create_new: 'new_company_button',
      info_button: 'info',
      new: {
        company_name: 'company_name',
        client_select: 'client_select',
        picture_uri: 'input_gallery-item-upload',
        submit: 'Create'
      }
    }
  },
  mobile_app: {
    notifications: {
      create_new: 'create_notification',
      title: 'title',
      content: 'content',
      select: 'select',
      send: 'send',
      send_later: 'send_later',
      confirm: 'confirm',
      info: 'info',
      clone_notification: 'clone_notification',
      schedule_date_time_id: 'schedule_date-time-id',
      send_later_submit: 'send_later_submit',
      edit: 'edit',
      save: 'save',
      delete: 'delete'
    },
    my_building: {
      table_list: 'my-building_table_list',
      edit_button: 'Edit_button',
      save_button: 'Save_button',
      error_modal: 'modal-error-modal',
      delete_image: 'delete-image',
      upload_image: 'gallery-item-upload'
    },

    articles: {
      table_list: 'articles_table_list',
      grid_list: 'articles_grid_list',
      grid_toggle_button: 'grid_toggle_button',
      new_article_button: 'articles_new_article_button',
      edit_article_button: 'articles_edit_article_button',
      new_button: 'New_button',
      delete_button: 'Delete_button',
      delete_confirm_modal: 'modal-delete-confirm-modal',
      delete_confirm_yes_button: 'delete-confirm-yes_button',
      delete_confirm_no_button: 'delete-confirm-no_button',
      edit_article_form: 'edit-article-form',
      create_new: 'new',
      title: 'title',
      section_select: 'section_select',
      category_select: 'category_select',
      article_body: 'article_body',
      publish_later: 'publish_later',
      publish_later_date: 'publish_date',
      publish_later_time: 'publish_time',
      submit: 'submit',
      confirm: 'confirm',
      row_info: 'row_info',
      edit_button: 'Edit',
      save_button: 'Save',
      error_modal: 'modal-error-modal'
    },

    events: {
      attendee_limit: 'attendee_limit-id',
      category_id: 'select-category_id',
      confirm_publish_modal: 'modal-confirm-publish-event',
      confirm_publish_yes_button: 'confirm_publish_yes_button',
      date: 'date-id',
      description: 'event_description',
      edit_event_button: 'events_edit_event_button',
      end_time: 'end_time-id',
      grid_list: 'events_grid_list',
      grid_toggle_button: 'grid_toggle_button',
      host: 'host-id',
      location: 'location-id',
      managed_externally: 'managed_externally_checkbox',
      name: 'name-id',
      new_event_button: 'new-event_button',
      new_event_form: 'create-event-form',
      price: 'price-id',
      publish_live_button: 'publish-live_button',
      start_time: 'start_time-id',
      table_list: 'events_table_list',
      table_toggle_button: 'table_toggle_button',
      terms_and_conditions: 'event_terms_and_conditions',
      url: 'url-id'
    },

    offers: {
      category_id: 'select-category_id',
      confirm_publish_modal: 'modal-confirm-publish-offer',
      confirm_publish_yes_button: 'publish-now_button',
      date: 'date-id',
      description: 'offer_description',
      edit_offer_button: 'offers_edit_offer_button',
      end_time: 'end_time-id',
      grid_list: 'offers_grid_list',
      grid_toggle_button: 'grid_toggle_button',
      host: 'host-id',
      location: 'nearest_location-id',
      managed_externally: 'managed_externally-id',
      new_offer_button: 'new-offer_button',
      new_offer_form: 'create-offer-form',
      offer_url: 'offer_url-id',
      publish_live_button: 'publish-live_button',
      publish_now_button: 'publish-now',
      retailer: 'retailer-id',
      start_time: 'start_time-id',
      table_list: 'offers_table_list',
      table_toggle_button: 'table_toggle_button',
      terms_and_conditions: 'offer_terms_and_conditions',
      title: 'title-id'
    }
  },

  building_management: {
    occupiers: {
      table_list: 'occupiers_table_list',
      new_occupier_button: 'new-occupier_button',
      new_occupier_form: 'new-occupier-form',
      industry_select: 'industry',
      contact_type_select: 'contact_type',
      create_button: 'create-occupier_button',
      company_name_input: 'company-name-input',
      company_id_input: 'company-id-input',
      company_search: 'company-search',
      company_search_input: 'company-search-input',
      floor_select: 'occupier-floor-select',
      confirm_create_modal: 'confirm-create',
      confirm_create_button: 'confirm-create-occupier_button',
      cancel_confirm_create_button: 'cancel-create-occupier_button',
      view_occupier_button: 'view-occupier_button',
      edit_modal: 'edit-occupier_modal',
      edit_occupier_button: 'edit-occupier_button',
      save_occupier_button: 'save-occupier_button',
      name_input: 'occupier-name-input',
      job_role_input: 'occupier-job-role-input',
      phone_input: 'occupier-job-role-input',
      email_input: 'occupier-email-input'
    },

    helpdesk: {
      create_new: 'new',
      floor_select: 'floor',
      location_select: 'location',
      description: 'description',
      submit: 'submit',
      confirm: 'confirm',
      table_list: 'helpdesk_table_list',
      row_info: 'row_info',
      comments_tab: 'comments',
      new_comment: 'add_comment-id',
      comment: 'comment',
      comment_container: 'comment_container',
      comment_date_header: 'comment_date_header',
      comment_date: 'comment_date'
    },

    visitor_management: {
      add_visitor: 'add_visitor',
      pre_book: 'new',
      arrival: 'arrival_time',
      visitor_type_select: 'visitor_type_select',
      visitor_name: 'visitor_name',
      visitor_company: 'visitor_company',
      occupier_select: 'occupier_select',
      host_name: 'host_name',
      submit: 'submit',
      confirm: 'confirm',
      search_button: 'search_button',
      search_box: 'search_box',
      table_list: 'visitor-management_table_list',
      nav_link_upcoming: 'nav-link-upcoming-',
      edit: 'Edit',
      new: 'new',
      save: 'Save',
      pass_preview: 'pass_preview',
      pdf_document: 'pdf_document',
      pass_print: 'pass_print',
      row_info: 'row_info',
      date_picker: 'visitor_date_picker',
      additional_visitors: {
        table: 'additional-visitors_table_list',
        add: 'add-guest'
      }
    },

    deliveries: {
      pre_book: 'new',
      confirm_terms: 'confirm_terms',
      continue: 'Continue',
      title: 'description',
      loading_bay: 'loading_bay_select',
      arrival: 'arrival_time_select',
      duration: 'duration_select',
      occupier_select: 'occupier_select',
      floor_select: 'floor_select',
      delivery_for: 'delivery_for',
      created_by: 'created_by',
      description: 'additional_details',
      is_recurring_booking: 'is_recurring_booking',
      is_not_recurring_booking: 'is_not_recurring_booking',
      recurrence_frequency: 'recurrence_frequency',
      recurrence_end_date: 'recurrence_end_date',
      submit: 'submit',
      confirm: 'confirm',
      table_list: 'deliveries_table_list',
      approve: 'approve',
      edit: 'Edit',
      save: 'Save',
      row_info: 'row_info',
      date_picker: 'deliveries_date_picker',
      recurrence_end_on: 'recurrence_end_on'
    },
    permits: {
      table_list: 'permits_table_list',
      row_info: 'row_info',
      new_permit_button: 'new_permit_button',
      access_only_yes: 'access_only_yes',
      access_only_no: 'access_only_no',
      work_at_height_checkbox:
        'disclaimerSection.workAtHeightRequired_checkbox',
      continue_button: 'continue_button',
      submit_button: 'submit_button',
      comments_tab: 'Comments-tab',
      add_comment: 'add_comment',
      send_comment: 'send_comment',
      comment: 'comment',
      example_comment: 'Hello. This is a test!',
      tabs_header: 'tabs_header',
      comment_date_headder: 'comment_date_header',
      comment_container: 'comment_container',
      comment_name: 'comment_name',
      comment_content: 'comment_content',
      comment_date: 'comment_date',
      comment_text: 'comment_text',
      comment_date_header: 'comment_date_header',
      comment_author_thumbnail: 'comment_author_thumbnail',
      /* job details */
      company_id: 'jobDetails.occupier',
      company_name: 'jobDetails.applicantCompanyName',
      contact_name: 'jobDetails.applicantContactName',
      contact_number: 'jobDetails.applicantContactNumber',
      contractor_company_name: 'contractorDetails.contractorCompanyName',
      end_time: 'jobDetails.permitValidRange.end-time-id',
      location: 'jobDetails.location',
      other_details: 'jobDetails.otherDetails-id',
      other_locations: 'jobDetails.otherLocations',
      reason: 'jobDetails.addReason-id',
      safety_measures: 'jobDetails.safetyInformation-id',
      start_time: 'jobDetails.permitValidRange.start-time-id',
      /* contractor details */
      company_number: 'contractorDetails.contractorContactNumber',
      supervisor_name: 'contractorDetails.supervisorName',
      supervisor_number: 'contractorDetails.supervisorContactNumber',
      edit_company_name: 'jobDetails.applicantCompanyName-id',
      edit_contact_number: 'jobDetails.applicantContactNumber-id',
      option_no: 'No',
      floor_select: 'jobDetails.floors',
      location_id: 'location_id',
      date_picker: 'date_picker',
      save: 'save',
      edit: 'edit',
      select: 'select',
      approved_by_text: 'permit-preview-approved-by',
      permit_print_preview: 'permit-preview-article',
      permit_preview_button: 'preview-permit'
    },
    lfa: {
      row_info: 'lfa_row_info'
    }
  },
  document_store: {
    download_file_button: 'download-confirm-yes',
    cancel_download_file_button: 'download-confirm-yes'
  }
};
